







































































    import {Component, Vue} from "vue-property-decorator";
    import {Getter, Mutation} from "vuex-class";
    import axios from "axios";
    import moment from "moment";
    import ReportContentGenerator from "@/valchrom/views/report/ReportContentGenerator.vue";
    import Loading from "@/valchrom/common/Loading.vue";
    import NewReportContentGenerator from "@/valchrom/views/report/NewReportContentGenerator.vue";

    interface Dataset {
        id: number;
        name: string;
    }

    interface Report {
        id: number;
        name: string;
        dataset: Dataset;
        content: string;
        last_saved: string;
        created_at: string;
    }

    @Component({
        components: {
            ReportContentGenerator, Loading, NewReportContentGenerator
        }
    })

    export default class EditReportView extends Vue {
        name= "EditReportView";
        dataLoaded = false;
        report : Report|any = {};
        generatorLoading : boolean = false;
        reportContent ?: string = "";

        // map getters
        @Getter base_url !: any;
        @Getter auth_header !: any;
        @Getter mathservice_start_date !: string;

        @Mutation SET_BREADCRUMB!: (_ : any) => any; //TODO: add type

        get generating(){
            return this.reportContent == undefined && this.generatorLoading;
        }

        getGenerator(){
            let createdMoment = moment(this.report.dataset.created_at);
            let isNew = createdMoment.isAfter(moment(this.mathservice_start_date));
            if(isNew){
                console.log("is new");
                return "NewReportContentGenerator";
            } else {
                return "ReportContentGenerator";
            }
        }

        mounted () {
            this.setBreadcrumb();

            let reportId = this.$route.params.id;
            this.report.id = reportId;

            axios.get(this.base_url + 'experiments/reports/'+reportId,
            {
                headers: this.auth_header,
                params: this.$route.query
            }).then(response => {
                console.log(response);
                this.dataLoaded = true;
                this.report = response.data;
                console.log("Report dataset got", this.report.dataset)
                this.reportContent = response.data.content;
                this.regenerate();
            })
            .catch(error => {
                console.log("Something went wrong getting reports", error);
            });
        }

        saveContents(){
            axios
                .patch(
                    this.base_url + 'experiments/reports/'+this.report.id,
                    {
                        content: this.reportContent
                    },
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    console.log("Report Successfully saved", response);
                    this.$toast.open({
                        message: `Saved contents.`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                })
                .catch(error => {
                    console.log("Report save error", error);
                });
        }

        resetContents(){
            this.$dialog.confirm({
                title: 'Clear content',
                message: 'Are you sure you want to clear report content from added texts. All changes you have added will be lost!',
                focusOn: 'cancel',
                onConfirm: () => {
                    this.reportContent = undefined;
                    this.regenerate();
                    this.$toast.open({
                        message: `Added content has been removed.`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                },
                onCancel: () => {
                }
            })

        }

        private regenerate() {
            let generator: any = this.$refs.generator as ReportContentGenerator;
            generator.reload();
        }

//original methods
        setBreadcrumb(){
            this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        }


        moment(val: any){
            return moment(val);
        }

        handleContentLoadingState(contentLoadingState:boolean){
            console.log("handleContentLoadingState",contentLoadingState);
            this.generatorLoading = contentLoadingState;
        }

        handleReportContent(content: string){
            console.log("handleReportContent",content.substr(0,30));
            if(this.reportContent == undefined){
                this.reportContent = content;
            }
        }
    }
